import { Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import type { FC } from "react";

interface NameCellProps {
  name: string;
}

export const NameCell: FC<NameCellProps> = ({ name }) => {
  const { customFontWeight } = useTheme();

  return (
    <Typography variant="body2" sx={{ fontWeight: customFontWeight.bold }}>
      {name}
    </Typography>
  );
};
